import { useSelector } from "react-redux";

export const useDefaultCard = () => {
  const { allCards, cardsById } = useSelector(
    ({ cardsReducer }) => cardsReducer,
  );

  const defaultCard = allCards.find((id) => cardsById?.[id]?.isDefault);

  return defaultCard || allCards[0];
};
